import "intersection-observer";
import ReactRailsUJS from "react_ujs";
import { setReactConstructor } from "../helpers/ViteHelper";
import { mountReactComponentsOnTurboLoad } from "../helpers/ReactUJS";
import baseFrontModules from "../helpers/entrypoint_modules/baseFront";

mountReactComponentsOnTurboLoad();

const modules = import.meta.globEager([
  "~/partials/erb_wrappers/ErbDownloadPdfQuoteButton.{js,jsx,ts,tsx}",
  "~/partials/designs/**/*.{js,jsx,ts,tsx}",
  "~/partials/comments/**/*.{js,jsx,ts,tsx}",
  "~/pages/designs/DesignViewerBom.{js,jsx,ts,tsx}",
  "~/pages/designs/DeploymentBundle.{js,jsx,ts,tsx}",
]);

const mergedModules = Object.assign(baseFrontModules, modules);

setReactConstructor(ReactRailsUJS, mergedModules);

/* Stimulus Controllers */
import { application } from "~/controllers/application";
import { registerControllers } from "stimulus-vite-helpers";

const controllers = import.meta.globEager([
  "~/controllers/design_card_carousel_controller.js",
  "~/controllers/popup_controller.js",
  "~/controllers/clipboard_controller.js",
  "~/controllers/thumbnails_gallery_controller.js",
  "~/controllers/read_more_controller.js",
  "~/controllers/like_button_controller.js",
  "~/controllers/section_viewer_dropdown_controller.js",
  "~/controllers/section_viewer_controller.js",
  "~/controllers/overlay_spinner_controller.js",
  "~/controllers/onchange_submit_form_controller.js",
  "~/controllers/quote_checkout_corporate_account_form_controller.js",
  "~/controllers/country_selector_controller.js",
  "~/controllers/google_places_autocomplete_controller.js",
  "/controllers/select_toggle_controller.js",
  "/controllers/automatically_click_on_self_controller.js",
  "/controllers/share_quote_form_controller.js",
  "/controllers/step_file_controller.js",
  "/controllers/download_bom_controller.js",
]);

registerControllers(application, controllers);
